import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
export const getUserDisplayName = (context, userId) => {
    const storage = context.storage(accountEntityName);
    return storage.getColumnValue('displayName', userId);
};
